export { FeaturedText } from "./FeaturedText";
export type { FeaturedTextProps } from "./FeaturedText";
